import { BaseChip } from "@/components/atom/chip/BaseChip";
import { COMMON_TEXT } from "@/constants/text";
import { ChipProps } from "@mantine/core";
import { ProductionPlansGet200ResponseRowsInnerWorksInnerTrackingStatusEnum } from "@sizlcorp/sizl-api-document/dist/models";

interface StatusChipProps extends ChipProps {
  value: keyof typeof ProductionPlansGet200ResponseRowsInnerWorksInnerTrackingStatusEnum;
}

const Status = {
  WAITING: COMMON_TEXT.STATUS.WAITING,
  PAUSED: COMMON_TEXT.STATUS.PAUSED,
  WORKING: COMMON_TEXT.STATUS.WORKING,
  DONE: COMMON_TEXT.STATUS.DONE,
};

const StatusColor = {
  WAITING: "yellow",
  PAUSED: "orange",
  WORKING: "lime",
  DONE: "blue",
};

export const StatusChip = ({ value, ...etcProps }: StatusChipProps) => {
  return (
    <BaseChip
      variant={"filled"}
      radius={"xs"}
      size={"md"}
      value={value}
      color={StatusColor[value]}
      {...etcProps}
    >
      {Status[value]}
    </BaseChip>
  );
};
